import { AxiosResponse } from 'axios'
import { apiNode } from './api'

import {
	GetAuditEventsParamsProps,
	GetAuditSchemeDataResponse,
	GetEventDetailsDataResponse,
	GetEventsDataResponse,
} from './types/audit.interfaces'
import { DefaultGetParamsProps } from './types/interfaces'
import { buildEventFiltersParams } from '../utils/filters/filtersBuilder'

const AUDIT_EVENTS_PAGE_SIZE = 100

const URL = '2/audit'

export const AuditService = {
	async getEvents({
		filters,
		orderBy,
		orderDirection,
		...params
	}: GetAuditEventsParamsProps): Promise<GetEventsDataResponse> {
		const response: AxiosResponse<GetEventsDataResponse> =
			await apiNode.get<GetEventsDataResponse>(`${URL}/events`, {
				params: {
					...params,
					...buildEventFiltersParams(filters),
					...(orderBy && { orderBy }),
					...(orderDirection !== undefined && { orderDirection }),
					timezoneOffset:
						filters?.startDate || filters?.endDate
							? new Date().getTimezoneOffset()
							: null,
					limit: AUDIT_EVENTS_PAGE_SIZE,
				},
			})
		return response.data
	},
	async getEventDetailsById({
		id,
	}: DefaultGetParamsProps): Promise<GetEventDetailsDataResponse> {
		const response: AxiosResponse<GetEventDetailsDataResponse> =
			await apiNode.get<GetEventDetailsDataResponse>(
				`${URL}/events/${id}/details`,
			)
		return response.data
	},
	async getScheme(): Promise<GetAuditSchemeDataResponse> {
		const response: AxiosResponse<GetAuditSchemeDataResponse> =
			await apiNode.get<GetAuditSchemeDataResponse>(`${URL}/scheme`)
		return response.data
	},
}
